import React, { Component } from "react";
import {
  Create,
  SaveButton,
  Toolbar,
  SimpleForm,
  SelectInput,
  REDUX_FORM_NAME,
  ReferenceInput,
  FormDataConsumer,
  TopToolbar,
  RefreshButton,
  TextInput,
  usePermissions,
  useRecordContext,
  DeleteButton
} from "react-admin";
// import { change } from 'redux-form';
import { useForm } from "react-hook-form";
// import { useForm, Form, createForm } from "react-final-form";
// import { change } from 'redux-form';
import { LineItemsSideComponent } from "./common";
import SaveWithOrderIdButton from "./singleDeliveryOrdersCreateButton";
import SaveWithNoteButton from "./saveWithNoteButton";
import Snackbar from "../snackbar";
import { getLocalStorageKey } from "../common/common";
import { useLocation, useNavigate } from 'react-router-dom';

const CreateActions = () => (
  <TopToolbar>
    <RefreshButton />
  </TopToolbar>
);

const sdoStatuses = [
  { id: "1", name: "New" },
  { id: "8", name: "Confirmed" },
];

const CreateToolbar = ({
  orderId,
  businessId,
  redirect,
}) => {

  const [showSnackbar, setShowSnackbar] = React.useState(false);

  return (
    <>
      <Toolbar>
        {/* <SaveWithOrderIdButton
                orderId={orderId}
                data={props}
            /> */}
        {/* <SaveWithNoteButton 
                orderId={orderId}
                data={props}
            /> */}

        <SaveButton
          alwaysEnable
          label="save"
          type="button"
          // redirect={`sap_digital_app_orders/${businessId}/show/2`}
          // redirect={history}
          onSuccess={() => (
            setShowSnackbar(true)
            // setTimeout(() => {
            //   navigate("/sap_digital_app_orders");
            // }, 2000)
          )}
          transform={(data) => ({ ...data , sap_digital_order_id: orderId})}
          submitOnEnter={false}
        />
      </Toolbar>
      {showSnackbar && <Snackbar message="Element Created" />}
    </>
  );
};

const OrderOrigin = ({ formData }) => {
  const { permissions } = usePermissions();
  const location = useLocation();
  const form = useForm();

  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  // console.log(props)

  const orderNumber =
    location.state &&
    location.state.order &&
    location.state.order.order_number;
  const orderId =
    location.state &&
    location.state.order &&
    location.state.order.id;
  const businessId =
    location.state &&
    location.state.order &&
    location.state.order.business_id;
  const lineItems =
    location.state &&
    location.state.order &&
    location.state.order.digital_order_line_items;

  const plantCode =
    location.state &&
    location.state.order &&
    location.state.order.sap_plant.plant_code;
  const record = { order_number: orderNumber, delivery_plant_no: plantCode };

  return (
    <React.Fragment>
      <TextInput label="Order Number" source="order_number" />
      {sdoFieldSettings &&
        sdoFieldSettings.shipment_number &&
        sdoFieldSettings.shipment_number.enabled && (
          <TextInput label="Shipment Number" source="shipment_number" />
        )}
      {
        sdoFieldSettings &&
        sdoFieldSettings.load_number &&
        sdoFieldSettings.load_number.enabled && (
          // <FormDataConsumer>
          //     {({ formData, dispatch }) => (
          <TextInput
            label="Loading Number"
            onChange={({ target: { value } }) => {
              // console.log("dispatch", formData, REDUX_FORM_NAME, value);
              if (!formData.truck_plate_no) {
                if (formData.delivery_plant_no) {
                  if (value) {
                    form.setValue("order_status", "8");
                    // form.change(REDUX_FORM_NAME, 'order_status', "8");
                  } else {
                    form.setValue("order_status", "5");
                  }
                }
              }
            }}
            source="load_number"
          />
        )
        //         )
        //     }
        // </FormDataConsumer>
      }
      {/* <FormDataConsumer>
                {({ formData, dispatch, ...rest }) => ( */}
      {/* <ReferenceInput
                        className="plant-select-input"
                        onChange={({target: {value}}) => {
                            console.log(value,'++++++++' ,formData);
                            if (!formData.truck_plate_no) {
                                if (formData.load_number) {
                                    if (value) {
                                        form.setValue('order_status', "8");
                                        // form.change(REDUX_FORM_NAME, 'order_status', "8");
                                    } else {
                                        form.setValue('order_status', "5");
                                    }
                                }
                            }
                        }}
                        filter={{business_id: businessId}}
                        source="delivery_plant_no"
                        reference="sap_plants"
                        label="Plant"
                        allowEmpty
                        // {...rest}
                    >
                        <SelectInput FormHelperTextProps={{ classes: { root: 'hide-helper' } }} optionText="name" optionValue="plant_code"/>
                    </ReferenceInput> */}
      {/* )
                }
            </FormDataConsumer> */}
      <SelectInput
        source="order_status"
        choices={sdoStatuses}
        defaultValue="5"
      />
    </React.Fragment>
  );
};


const SingleDeliveryOrdersCreate = ({ ...props }) => {
  const { permissions } = usePermissions();
  const location = useLocation();
  console.log("location...SingleDelivery", location);
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");

  const orderNumber =
    location.state &&
    location.state.order &&
    location.state.order.order_number;
  const orderId =
    location.state &&
    location.state.order &&
    location.state.order.id;
  const businessId =
    location.state &&
    location.state.order &&
    location.state.order.business_id;
  const lineItems =
    location.state &&
    location.state.order &&
    location.state.order.digital_order_line_items;

  const plantCode =
    location.state &&
    location.state.order &&
    location.state.order.sap_plant.plant_code;
  const record = { order_number: orderNumber, delivery_plant_no: plantCode };

  const CreateRedirect = (_basePath, _id, data) => `sap_digital_orders/${orderId}/show/2`

  return (
    <Create
      className="sdo-form"
      title="Create SDO"
      redirect={CreateRedirect}
      aside={
        <LineItemsSideComponent
          digital_order={{ digital_order_line_items: lineItems }}
        />
      }
      actions={<CreateActions permissions={permissions} />}
      record={record}
      // {...props}
    >
      <SimpleForm
        toolbar={
          <CreateToolbar
            orderId={orderId}
            businessId={businessId}
            // data={props}
          />
        }
        className="half-grid"
      >
        {/* <SimpleForm  className="half-grid"> */}
        <FormDataConsumer>
          {(formDataProps) => <OrderOrigin {...formDataProps} />}
        </FormDataConsumer>
      </SimpleForm>
    </Create>
  );
  // }
};

export default SingleDeliveryOrdersCreate;
